import React from 'react';
import { Card, CardContent, Grid, Typography, makeStyles } from '@material-ui/core';
import {
  DAUIcon,
  DownTrendGraph,
  LearningUnitIcon,
  MAUIcon,
  RockedScoreIcon,
  UpTrendGraph,
} from '../../assets/PXDashboardDataIcons';

const CARD_ICONS = {
  mau: <MAUIcon height="50px" width="50px" />,
  dau: <DAUIcon height="50px" width="50px" />,
  lu: <LearningUnitIcon height="50px" width="50px" />,
  rs: <RockedScoreIcon height="50px" width="50px" />,
};

const TREND = {
  up: <UpTrendGraph height="10px" width="18px" />,
  down: <DownTrendGraph height="10px" width="18px" />,
};

const useStyle = makeStyles(() => ({
  card: {
    height: '120px',
    width: '90%',
    borderRadius: '8px',
    position: 'relative',
    border: 0,
  },
  title: {
    fontWeight: '500',
    fontSize: '12px',
    lineHeight: '16.32px',
    padding: '5px',
  },
  value: {
    fontWeight: '700',
    fontSize: '20px',
    lineHeight: '28px',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingRight: '10px',
    paddingLeft: '5px',
  },
  subtext: {
    fontSize: '12px',
    fontWeight: '400',
  },
}));

export default function PXMetrics({ title, value, type, delta, subtext, color }) {
  const classes = useStyle();
  return (
    <Card className={classes.card} variant="outlined">
      <CardContent>
        <Grid container direction="column">
          <Grid item className={classes.title}>
            {title}
          </Grid>
          <Grid item className={classes.value}>
            {value}
          </Grid>
          <Grid>
            {delta ? (
              <Grid style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                {color === '#D92D20' ? TREND.down : TREND.up}
                <Typography className={classes.subtext}>
                  <span style={{ color, fontWeight: '600' }}>{delta} </span> {subtext}
                </Typography>
              </Grid>
            ) : (
              <Typography varient="body1">--</Typography>
            )}
          </Grid>
        </Grid>
        <span style={{ position: 'absolute', top: 10, right: 10 }}>{CARD_ICONS[type]}</span>
      </CardContent>
    </Card>
  );
}
